/* pokelockbox – "The Vault" theme JS.
   Vanilla, dependency-free, loaded with defer. Everything degrades to plain HTML forms and links without JS.
   Modules: header, announcement, images, tilt, reveal, carousel, cart (+drawer), product, recommendations,
   collection (filters, grid toggle, load more), consent. */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, settings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* =====================================================================
     Header: glass on scroll, header height var, one open dropdown at a time
     ===================================================================== */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var dropdowns = $$('details[data-mega], details[data-search], details[data-drawer]', header);

    function closeAll(except) {
      dropdowns.forEach(function (d) { if (d !== except) d.removeAttribute('open'); });
    }

    dropdowns.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          closeAll(d);
          header.classList.add('has-open');
          if (d.hasAttribute('data-search')) {
            var input = $('input[type="search"]', d);
            if (input) setTimeout(function () { input.focus(); }, 30);
          }
          if (d.hasAttribute('data-drawer')) {
            setHeaderVars();
            document.body.style.overflow = 'hidden';
          }
        } else {
          if (!dropdowns.some(function (x) { return x.open; })) header.classList.remove('has-open');
          if (d.hasAttribute('data-drawer')) document.body.style.overflow = '';
        }
      });
    });

    // Hover intent for mega menus on fine pointers (click still works)
    if (finePointer.matches) {
      $$('details[data-mega]', header).forEach(function (d) {
        var timer;
        d.addEventListener('mouseenter', function () { clearTimeout(timer); if (!d.open) { closeAll(d); d.setAttribute('open', ''); } });
        d.addEventListener('mouseleave', function () { timer = setTimeout(function () { d.removeAttribute('open'); }, 180); });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = dropdowns.filter(function (d) { return d.open; })[0];
      if (open) {
        open.removeAttribute('open');
        var summary = $('summary', open);
        if (summary) summary.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll(null);
    });

    function setHeaderVars() {
      var rect = header.getBoundingClientRect();
      document.documentElement.style.setProperty('--header-bottom', Math.max(0, rect.bottom) + 'px');
      document.documentElement.style.setProperty('--header-h', rect.height + 'px');
    }
    setHeaderVars();
    window.addEventListener('resize', setHeaderVars, { passive: true });

    // Glass state
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('is-scrolled', window.scrollY > 24 || header.classList.contains('has-open'));
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    dropdowns.forEach(function (d) { d.addEventListener('toggle', onScroll); });
  }

  /* ===================================================================== Announcement rotation */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var items = $$('.announcement__item', bar);
    if (items.length < 2 || reduceMotion.matches) {
      if (items.length > 1) items.forEach(function (el, i) { if (i > 0) el.remove(); });
      return;
    }
    var i = 0, paused = false;
    ['mouseenter', 'focusin'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = true; }); });
    ['mouseleave', 'focusout'].forEach(function (ev) { bar.addEventListener(ev, function () { paused = false; }); });
    setInterval(function () {
      if (paused) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  }

  /* ===================================================================== Images: fade-in, skeleton off */
  function initImages(root) {
    $$('img[data-fade]', root || document).forEach(function (img) {
      if (img.hasAttribute('data-fade-bound')) return;
      img.setAttribute('data-fade-bound', '');
      function done() {
        img.classList.add('is-loaded');
        var wrap = img.closest('.skeleton');
        if (wrap) wrap.classList.add('is-loaded');
      }
      if (img.complete && img.naturalWidth > 0) done();
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });
    // Skeletons with no image (placeholders)
    $$('.skeleton', root || document).forEach(function (el) {
      if (!$('img', el)) el.classList.add('is-loaded');
    });
  }

  /* ===================================================================== Holo-tilt */
  function initTilt(root) {
    if (!theme.settings || !theme.settings.tilt) return;
    if (!finePointer.matches || reduceMotion.matches) return;
    $$('[data-tilt]', root || document).forEach(function (el) {
      if (el.hasAttribute('data-tilt-bound')) return;
      el.setAttribute('data-tilt-bound', '');
      var gentle = el.hasAttribute('data-tilt-gentle');
      var max = gentle ? 4 : 8;
      var raf = null, pending = null;

      function apply() {
        raf = null;
        if (!pending) return;
        var rect = pending.rect, x = pending.x, y = pending.y;
        var px = (x - rect.left) / rect.width;   // 0..1
        var py = (y - rect.top) / rect.height;
        el.style.setProperty('--tilt-y', ((px - 0.5) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--tilt-x', ((0.5 - py) * max * 2).toFixed(2) + 'deg');
        el.style.setProperty('--sheen-x', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--sheen-y', (py * 100).toFixed(1) + '%');
      }
      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        el.classList.add('is-tilting');
      });
      el.addEventListener('pointermove', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        pending = { rect: el.getBoundingClientRect(), x: e.clientX, y: e.clientY };
        if (!raf) raf = requestAnimationFrame(apply);
      });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('is-tilting');
        el.style.setProperty('--tilt-x', '0deg');
        el.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  /* ===================================================================== Scroll reveal */
  function initReveal() {
    if (!theme.settings || !theme.settings.reveal) return;
    if (reduceMotion.matches || !('IntersectionObserver' in window)) { document.body.classList.remove('reveal-on'); return; }
    var targets = [];
    $$('#MainContent > .shopify-section').forEach(function (section, idx) {
      if (section.classList.contains('section-hero') || section.classList.contains('section-main-product')) return;
      // reveal the section's direct content block; stagger grid children lightly
      section.setAttribute('data-reveal', '');
      targets.push(section);
      var kids = $$('.product-grid > li, .trust__item, .why__card, .setpills__grid > li, .bento--types > li, .drops__list > li', section);
      kids.forEach(function (k, i) {
        if (i > 11) return;
        k.setAttribute('data-reveal', '');
        k.style.setProperty('--reveal-delay', Math.min(i * 45, 400) + 'ms');
        targets.push(k);
      });
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) {
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) t.classList.add('is-revealed'); // already on screen: no fade-in
      else io.observe(t);
    });
  }

  /* ===================================================================== Carousels */
  function initCarousels(root) {
    $$('[data-carousel]', root || document).forEach(function (track) {
      if (track.hasAttribute('data-carousel-bound')) return;
      track.setAttribute('data-carousel-bound', '');
      var section = track.closest('section') || track.parentElement;
      var nav = $('[data-carousel-nav]', section);
      if (!nav) return;
      var prev = $('[data-carousel-prev]', nav), next = $('[data-carousel-next]', nav);
      function step() { var slide = $('.carousel__slide', track); return slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8; }
      function update() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ===================================================================== Toast + cart count */
  var toastTimer;
  function showToast(text, isError) {
    var toast = $('#CartToast');
    if (!toast) return;
    $('[data-toast-text]', toast).textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }

  function setCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-drawer-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0; });
    $$('[data-cart-link]').forEach(function (el) {
      var label = el.getAttribute('aria-label') || '';
      el.setAttribute('aria-label', label.replace(/\d+/, count));
    });
  }

  function fetchCart() {
    return fetch(theme.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ===================================================================== Cart drawer */
  var drawer = {
    el: null, panel: null, body: null, lastFocus: null,
    init: function () {
      this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      this.panel = $('.cart-drawer__panel', this.el);
      this.body = $('[data-cart-drawer-body]', this.el);
      var self = this;

      $$('[data-cart-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey) return;
          e.preventDefault();
          self.open();
        });
      });
      this.el.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
      this.bindLines();
    },
    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var self = this;
      setTimeout(function () { self.panel.focus(); }, 50);
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    refresh: function () {
      var self = this;
      if (!this.el) return Promise.resolve();
      return fetch(theme.routes.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer]', doc);
          if (!fresh) return;
          var isOpen = self.el.classList.contains('is-open');
          self.el.innerHTML = fresh.innerHTML;
          self.panel = $('.cart-drawer__panel', self.el);
          self.body = $('[data-cart-drawer-body]', self.el);
          if (isOpen) { self.el.classList.add('is-open'); self.el.setAttribute('aria-hidden', 'false'); }
          initImages(self.el);
          self.bindLines();
        })
        .catch(function () {});
    },
    bindLines: function () {
      var self = this;
      if (!this.body) return;
      $$('.cart-line', this.body).forEach(function (line) {
        var key = line.getAttribute('data-key');
        var input = $('[data-line-input]', line);
        var timer;
        function change(qty) {
          qty = Math.max(0, qty);
          var max = input && input.max ? parseInt(input.max, 10) : Infinity;
          if (qty > max) qty = max;
          self.body.classList.add('is-busy');
          fetch(theme.routes.cartChange, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
          })
            .then(function (r) { return r.json(); })
            .then(function (cart) { setCartCount(cart.item_count); return self.refresh(); })
            .catch(function () { showToast(theme.strings.addError, true); })
            .finally(function () { if (self.body) self.body.classList.remove('is-busy'); });
        }
        var minus = $('[data-line-minus]', line), plus = $('[data-line-plus]', line), remove = $('[data-line-remove]', line);
        if (minus) minus.addEventListener('click', function () { change(parseInt(input.value, 10) - 1); });
        if (plus) plus.addEventListener('click', function () { change(parseInt(input.value, 10) + 1); });
        if (input) input.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(function () { change(parseInt(input.value, 10) || 0); }, 300); });
        if (remove) remove.addEventListener('click', function (e) { e.preventDefault(); change(0); });
      });
    }
  };

  /* ===================================================================== AJAX add to cart */
  function initAjaxCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();

      var button = $('[type="submit"]', form);
      var errorBox = $('[data-form-error]', form);
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      if (errorBox) errorBox.hidden = true;

      fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || theme.strings.addError;
            if (errorBox) { errorBox.textContent = msg; errorBox.hidden = false; }
            showToast(msg, true);
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:added', { detail: res.data }));
          return fetchCart().then(function (cart) {
            setCartCount(cart.item_count);
            if (theme.settings.cartDrawer && drawer.el) {
              return drawer.refresh().then(function () { drawer.open(); });
            }
            showToast(theme.strings.added);
          });
        })
        .catch(function () { form.submit(); })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-busy');
            if (!button.hasAttribute('data-sold-out')) button.disabled = false;
          }
        });
    });
  }

  /* ===================================================================== Product page */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;
    var dataEl = $('[data-product-json]', root);
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var form = $('#ProductForm', root);
    var idInput = $('[data-variant-id]', root);
    var preorderInput = $('[data-preorder-property]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var qtyInput = $('[data-qty-input]', root);
    var picker = $('[data-variant-picker]', root);
    var errorBox = $('[data-form-error]', root);
    var dynamic = $('[data-dynamic-checkout]', root);
    var sticky = $('[data-sticky-bar]');

    function selectedOptions() {
      if (!picker) return null;
      return $$('.variant-picker__group', picker).map(function (g) {
        var checked = $('input:checked', g);
        return checked ? checked.value : null;
      });
    }
    function findVariant(options) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      })[0];
    }
    function badgeText(status) {
      var t = data.statusLabels[status] || '';
      if (status === 'preorder' && data.release) t += ' · ' + data.release;
      return t;
    }
    function setBadge(el, status) {
      if (!el) return;
      el.className = 'badge badge--' + status;
      el.textContent = badgeText(status);
    }
    function markUnavailable(options) {
      if (!picker) return;
      $$('.variant-picker__group', picker).forEach(function (group, gi) {
        $$('input', group).forEach(function (input) {
          var test = options.slice();
          test[gi] = input.value;
          var v = findVariant(test);
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function setButtons(v) {
      var stickyBtn = sticky ? $('[data-sticky-add]', sticky) : null;
      var stickyLabel = sticky ? $('[data-sticky-label]', sticky) : null;
      var stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
      var label;
      if (!v) { label = data.buttonLabels.unavailable; }
      else if (!v.available) { label = data.buttonLabels.soldOut; }
      else { label = v.status === 'preorder' ? data.buttonLabels.preorder : data.buttonLabels.add; }
      var disabled = !v || !v.available;
      addBtn.disabled = disabled;
      if (disabled) addBtn.setAttribute('data-sold-out', ''); else addBtn.removeAttribute('data-sold-out');
      addLabel.textContent = label;
      if (stickyBtn) stickyBtn.disabled = disabled;
      if (stickyLabel) stickyLabel.textContent = label;
      if (stickyPrice && v) stickyPrice.textContent = v.price;
      if (dynamic) dynamic.hidden = disabled;
    }

    function update() {
      var options = selectedOptions();
      if (!options) return;
      $$('[data-option-value]', root).forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-value'), 10);
        el.textContent = options[idx] || '';
      });
      markUnavailable(options);
      var v = findVariant(options);
      if (errorBox) errorBox.hidden = true;
      if (!v) { setButtons(null); return; }

      idInput.value = v.id;
      var priceCurrent = $('[data-price-current]', root);
      if (priceCurrent) priceCurrent.textContent = v.price;
      var priceCompare = $('[data-price-compare]', root);
      if (priceCompare) { priceCompare.textContent = v.compare || ''; priceCompare.hidden = !v.compare; }
      $$('[data-stock-badge]', root).forEach(function (el) { setBadge(el, v.status); });
      var skuRow = $('[data-sku-row]', root), sku = $('[data-sku]', root);
      if (sku) sku.textContent = v.sku || '';
      if (skuRow) skuRow.hidden = !v.sku;

      var isPre = v.status === 'preorder';
      if (preorderInput) preorderInput.disabled = !isPre;
      var shipIn = $('[data-ship-instock]', root), shipPre = $('[data-ship-preorder]', root);
      if (shipIn) shipIn.hidden = isPre;
      if (shipPre) shipPre.hidden = !isPre;

      setButtons(v);

      if (qtyInput) {
        if (v.max) { qtyInput.max = v.max; if (parseInt(qtyInput.value, 10) > v.max) qtyInput.value = v.max; }
        else qtyInput.removeAttribute('max');
      }
      if (v.mediaId) {
        var thumb = $('[data-thumb][data-media-id="' + v.mediaId + '"]', root);
        if (thumb) showMedia(thumb);
      }
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) { picker.addEventListener('change', update); markUnavailable(selectedOptions()); }

    // quantity
    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    function clampQty(n) { var max = qtyInput.max ? parseInt(qtyInput.max, 10) : Infinity; return Math.max(1, Math.min(max, n || 1)); }
    if (minus && qtyInput) minus.addEventListener('click', function () { qtyInput.value = clampQty(parseInt(qtyInput.value, 10) - 1); });
    if (plus && qtyInput) plus.addEventListener('click', function () { qtyInput.value = clampQty(parseInt(qtyInput.value, 10) + 1); });
    if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(parseInt(qtyInput.value, 10)); });

    // gallery
    var mainImg = $('[data-main-image]', root), zoomImg = $('[data-zoom-image]', root);
    function showMedia(thumb) {
      if (!mainImg) return;
      mainImg.classList.remove('is-loaded');
      mainImg.src = thumb.getAttribute('data-src');
      mainImg.srcset = thumb.getAttribute('data-srcset');
      mainImg.alt = thumb.getAttribute('data-alt');
      mainImg.addEventListener('load', function () { mainImg.classList.add('is-loaded'); }, { once: true });
      if (zoomImg) { zoomImg.src = thumb.getAttribute('data-full'); zoomImg.alt = thumb.getAttribute('data-alt'); }
      $$('[data-thumb]', root).forEach(function (t) {
        var active = t === thumb;
        t.classList.toggle('is-active', active);
        if (active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    $$('[data-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });

    // zoom dialog
    var dialog = $('[data-zoom-dialog]', root), openBtn = $('[data-zoom-open]', root), stage = $('[data-zoom-stage]', root);
    if (dialog && openBtn && typeof dialog.showModal === 'function') {
      openBtn.addEventListener('click', function () { if (zoomImg) zoomImg.loading = 'eager'; dialog.showModal(); });
      $('[data-zoom-close]', dialog).addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('close', function () { stage.classList.remove('is-zoomed'); openBtn.focus(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
      stage.addEventListener('click', function (e) {
        var zoomed = stage.classList.toggle('is-zoomed');
        if (zoomed && zoomImg) {
          var rect = zoomImg.getBoundingClientRect();
          var x = (e.clientX - rect.left) / rect.width, y = (e.clientY - rect.top) / rect.height;
          requestAnimationFrame(function () {
            stage.scrollLeft = x * stage.scrollWidth - stage.clientWidth / 2;
            stage.scrollTop = y * stage.scrollHeight - stage.clientHeight / 2;
          });
        }
      });
    } else if (openBtn && zoomImg) {
      openBtn.addEventListener('click', function () { window.open(zoomImg.src, '_blank', 'noopener'); });
    }

    // sticky mobile bar: show once the main button scrolls out of view
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      function syncSticky() {
        var r = addBtn.getBoundingClientRect();
        sticky.classList.toggle('is-visible', r.bottom < 0);
      }
      var io = new IntersectionObserver(function () { syncSticky(); }, { threshold: 0 });
      io.observe(addBtn);
      var stickyRaf = null;
      window.addEventListener('scroll', function () {
        if (stickyRaf) return;
        stickyRaf = requestAnimationFrame(function () { stickyRaf = null; syncSticky(); });
      }, { passive: true });
      var stickyAdd = $('[data-sticky-add]', sticky);
      if (stickyAdd && form) {
        stickyAdd.addEventListener('click', function () {
          if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
        });
      }
    }
  }

  /* ===================================================================== Product recommendations */
  function initRecommendations() {
    var section = $('[data-recommendations]');
    if (!section) return;
    var url = section.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recommendations]', doc);
        if (!fresh || !$('.product-grid', fresh)) return;
        section.innerHTML = fresh.innerHTML;
        initImages(section); initTilt(section); initCarousels(section);
      })
      .catch(function () {});
  }

  /* ===================================================================== Collection: filters, grid toggle, load more */
  function initCollection() {
    var form = $('[data-filters]');
    if (form) {
      var timer;
      form.addEventListener('change', function (e) {
        clearTimeout(timer);
        var delay = e.target.type === 'number' ? 700 : 0;
        timer = setTimeout(function () {
          $$('input[type="number"]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
          form.submit();
        }, delay);
      });
      document.addEventListener('click', function (e) {
        $$('.filters__group[open]', form).forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
      });
    }

    var grid = $('[data-product-grid]');
    var toggle = $('[data-grid-toggle]');
    if (grid && toggle) {
      var key = 'plb:grid-cols';
      var saved = null;
      try { saved = window.localStorage.getItem(key); } catch (err) {}
      var current = saved || grid.getAttribute('data-default-cols') || '4';
      function applyCols(cols) {
        ['2', '3', '4'].forEach(function (c) { grid.classList.remove('product-grid--cols-' + c); });
        grid.classList.add('product-grid--cols-' + cols);
        $$('.gridtoggle__btn', toggle).forEach(function (b) {
          var active = b.getAttribute('data-cols') === cols;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      }
      if (window.matchMedia('(min-width: 990px)').matches) applyCols(current);
      else $$('.gridtoggle__btn', toggle).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      toggle.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-cols]');
        if (!btn) return;
        applyCols(btn.getAttribute('data-cols'));
        try { window.localStorage.setItem(key, btn.getAttribute('data-cols')); } catch (err) {}
      });
    }

    var loadmore = $('[data-loadmore]');
    if (grid && loadmore) {
      var btn = $('[data-loadmore-btn]', loadmore);
      var status = $('[data-loadmore-status]', loadmore);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var next = btn.getAttribute('href');
        if (!next) return;
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        fetch(next, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var items = $$('[data-product-grid] > li', doc);
            items.forEach(function (li) { li.classList.add('is-new'); grid.appendChild(li); });
            initImages(grid); initTilt(grid);
            var nextBtn = $('[data-loadmore-btn]', doc);
            var nextStatus = $('[data-loadmore-status]', doc);
            if (status && nextStatus) status.textContent = nextStatus.textContent;
            if (nextBtn) { btn.setAttribute('href', nextBtn.getAttribute('href')); btn.disabled = false; }
            else {
              btn.remove();
              var count = $('[data-collection-count]');
              if (status && count) status.textContent = count.textContent;
            }
            if (window.history && window.history.replaceState) window.history.replaceState({}, '', next);
            var first = items[0] ? $('a', items[0]) : null;
            if (first) first.focus({ preventScroll: true });
          })
          .catch(function () { window.location.href = next; })
          .finally(function () { btn.removeAttribute('aria-busy'); });
      });
    }
  }

  /* ===================================================================== Cart page */
  function initCartPage() {
    var form = $('[data-cart-form]');
    if (!form) return;
    var timer;
    $$('[data-cart-qty]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          var hidden = document.createElement('input');
          hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
          form.appendChild(hidden);
          form.submit();
        }, 400);
      });
    });
  }

  /* ===================================================================== Cookie consent (Shopify Customer Privacy API) */
  function initConsent() {
    var banner = $('#CookieBanner');
    if (!banner) return;
    function withPrivacyApi(cb) {
      if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) return;
        if (window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
    withPrivacyApi(function (api) {
      var shouldShow = typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() : false;
      if (shouldShow) banner.hidden = false;
      $$('[data-consent]', banner).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var granted = btn.getAttribute('data-consent') === 'accept';
          api.setTrackingConsent({ analytics: granted, marketing: granted, preferences: granted }, function () { banner.hidden = true; });
        });
      });
      $$('[data-open-cookie-banner]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          banner.hidden = false;
          var first = $('button', banner);
          if (first) first.focus();
        });
      });
    });
  }

  /* ===================================================================== Theme editor hooks */
  function initEditor() {
    if (!window.Shopify || !window.Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function (e) {
      initImages(e.target); initTilt(e.target); initCarousels(e.target);
      $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
    });
  }

  function init() {
    initHeader();
    initAnnouncement();
    initImages();
    initTilt();
    initCarousels();
    drawer.init();
    initAjaxCart();
    initProduct();
    initRecommendations();
    initCollection();
    initCartPage();
    initConsent();
    initEditor();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
